import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-field-link-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [class]="iconClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.81666 13.3497C6.18333 13.2913 5.55833 12.9997 5.075 12.4913C3.975 11.333 3.975 9.433 5.075 8.27466L6.9 6.35801C8 5.19967 9.80834 5.19967 10.9167 6.35801C12.0167 7.51634 12.0167 9.41634 10.9167 10.5747L10.0083 11.533"
        stroke="#2970FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M13.1828 6.64941C13.8162 6.70775 14.4412 6.99941 14.9245 7.50775C16.0245 8.66608 16.0245 10.5661 14.9245 11.7244L13.0995 13.6411C11.9995 14.7994 10.1911 14.7994 9.08281 13.6411C7.98281 12.4827 7.98281 10.5827 9.08281 9.4244L9.99116 8.46607"
        stroke="#2970FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.50033 18.3337H12.5003C16.667 18.3337 18.3337 16.667 18.3337 12.5003V7.50033C18.3337 3.33366 16.667 1.66699 12.5003 1.66699H7.50033C3.33366 1.66699 1.66699 3.33366 1.66699 7.50033V12.5003C1.66699 16.667 3.33366 18.3337 7.50033 18.3337Z"
        stroke="#2970FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class FieldLinkIconComponent extends BaseIconComponent {}
